// ============================================================
//  MOBY SHOP Orašje — konfiguracija stranice
//  Ovdje možeš lako mijenjati ključne podatke.
// ============================================================

export const STORE = {
  name: "MOBY SHOP",
  city: "Orašje",
  tagline: "Tehnika i knjige na jednom mjestu — od 2004.",
  since: 2002,
  address: "8. ulica broj 16, Orašje",
  email: "dejansmajlovic@hotmail.com",
  phone: "+387 31 713 666",
  mobile: "+387 63 690 087",

  // ============== DRUŠTVENE MREŽE ==============
  facebook: {
    handle: "@mobyshoporasje",
    url: "https://www.facebook.com/mobyshoporasje",
  },
  instagram: {
    handle: "@moby_shop_orasje",
    url: "https://www.instagram.com/moby_shop_orasje/",
  },

  // ============== MESSENGER ZA NARUDŽBE ==============
  // Klik na "Naruči putem Messengera" otvara: https://m.me/mobyshoporasje
  messengerUsername: "mobyshoporasje",

  // ============== RADNO VRIJEME ==============
  hours: [
    { day: "Ponedjeljak – Petak", time: "08:00 — 19:00" },
    { day: "Subota", time: "08:00 — 16:00" },
    { day: "Nedjelja", time: "Ne radimo" },
  ],
};

// ============== SLIKE — ZAMJENA ==============
// Svaka slika ispod ima komentar gdje da staviš svoju sliku.
// Ako nemaš još slike, zadržat će se ove profesionalne placeholder slike.
export const IMAGES = {
  // 🖼️ HERO SLIDER — glavne slike na vrhu stranice (1920x1080)
  hero: [
    // [USER] Stavi sliku eksterijera radnje (vanjski izgled). 1920x1080 px.
    "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=1920&q=85",
    // [USER] Stavi sliku unutrašnjosti trgovine.
    "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=1920&q=85",
    // [USER] Stavi sliku polica s proizvodima.
    "https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?w=1920&q=85",
  ],

  // 🖼️ LOGO — zamijeni svojom logo slikom (prozirni PNG, ~200x200)
  // [USER] Stavi svoj LOGO ovdje. Najbolje PNG sa providnom pozadinom.
  logo: null, // ako null → koristit će se tekstualni logo

  // 🖼️ POVIJEST RADNJE — slike vaše lokacije (od 2004)
  historyGallery: [
    // [USER] Stara/nova slika radnje 1
    "https://images.pexels.com/photos/2079438/pexels-photo-2079438.jpeg?auto=compress&w=900",
    // [USER] Slika radnje 2
    "https://images.pexels.com/photos/1005638/pexels-photo-1005638.jpeg?auto=compress&w=900",
    // [USER] Slika radnje 3
    "https://images.pexels.com/photos/3965545/pexels-photo-3965545.jpeg?auto=compress&w=900",
  ],

  // 🖼️ MASKOTA KNJIŽARE — torba koja priča
  // [USER] Možeš zamijeniti vlastitom ilustracijom/PNG-om torbe (prozirna pozadina).
  bagMascot: "https://images.unsplash.com/photo-1622560480654-d96214fdc887?w=600&q=85",
};

export const SHOPS = [
  { key: "moby_shop", label: "Moby Shop", description: "Mobiteli, laptopi, oprema i tehnika" },
  { key: "knjizara", label: "Knjižara", description: "Školski pribor, knjige, pernice, torbe" },
];
